module.exports = __webpack_public_path__ + "static/media/hip_evaluation_home.84440133.png";